import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/iview'
import './plugins/beepay'
import './plugins/mixin'
import http from '@/libs/http'
import config from '@/config'
import * as utils from '@/libs/appUtils'
import './index.less'

Vue.prototype.$utils = utils
Vue.prototype.$http = http
Vue.prototype.$config = config

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
